import { useGetMyPermissionsQuery } from "../../../store/api/rbacApi";

// Interim gate for the Workforce Lifecycle Management module (same convention
// as CUSTOM_DOMAIN_UI_ENABLED in AppLayout.tsx). Migration to a server-driven
// RBAC nav flag is a later spec; until then WLM is admin-only behind this const.
export const WORKFORCE_LIFECYCLE_ENABLED = true;

export interface WorkforceGate {
  enabled: boolean;
  isLoading: boolean;
}

/**
 * Single source of truth for WLM visibility. Consumed by the header
 * ProductSwitcher, the AppLayout workforce branch, and the gated redirect.
 * Callers must not redirect away from /workforce while isLoading is true.
 */
export function useWorkforceGate(): WorkforceGate {
  const { data: rbacPermissions, isLoading } = useGetMyPermissionsQuery();

  const isAdmin = rbacPermissions?.isAdmin === true || rbacPermissions?.isB2CAdmin === true;

  return {
    enabled: WORKFORCE_LIFECYCLE_ENABLED && !isLoading && isAdmin,
    isLoading,
  };
}
